import { Campaign, UserInDetails } from '@hub/shared'
import { SqCallout } from '@squidit/react-css'
import { useTranslation } from 'react-i18next'
import './pre-recruitment.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  campaign: Campaign | undefined
  userSelected?: UserInDetails
}

export default ({ campaign, userSelected }: Props) => {
  const [t] = useTranslation('preRecruitment')

  if (!campaign) {
    return null
  }

  return (
    <section className="pre-recruitment">
      <hr />
      <div className="content">
        <h5>{t('detailsTitle')}</h5>
        <div className="clean-style" dangerouslySetInnerHTML={{ __html: campaign?.activation?.description }}></div>
      </div>
      <hr />
      <div className="content">
        <h5>{t('brandTitle')}</h5>
        <div className="clean-style" dangerouslySetInnerHTML={{ __html: campaign?.activation?.clientDescription }}></div>
      </div>
      {userSelected?.status === 'inContact' && campaign?.socialNetworks?.includes('tiktok') && campaign?.tcmCampaignCode ? (
        <SqCallout smallIconStyle icon="fa-solid fa-triangle-exclamation mr-2 sm yellow" title={t('titleWarning')}>
          {t('messageWarning')}
        </SqCallout>
      ) : null}
    </section>
  )
}
